import React from 'react'

import { SectorsDropdownType, SubMenuType } from '@contracts/wp/megaMenu'

import { usePageLinks } from '@hooks/usePageLinks'

import MegaMenuCards from './MegaMenuCards'
import MegaMenuItem from './MegaMenuItem'
import * as styles from './SectorsDropdown.module.scss'
import Submenu from './Submenu'

import ArrowIcon from '@icons/arrow-right-controlled.svg'

type Props = {
	data: SectorsDropdownType
}

const SectorsDropdown: React.FC<Props> = ({ data }) => {
	const [isSubmenuOpen, setIsSubmenuOpen] = React.useState(false)

	const { sectorsLinks, sectorsCards } = data

	const { sectorArchive } = usePageLinks()

	const submenuData: SubMenuType = sectorsLinks.map((sectorLink) => {
		return {
			megaMenuItem: sectorLink.megaMenuItem,
		}
	})

	const itemStyles = [styles.sectorsLink]

	if (submenuData) {
		itemStyles.push(styles.hasSubmenu)
	}

	const iconStyles = [styles.icon]

	if (isSubmenuOpen) {
		iconStyles.push(styles.isOpen)
	}

	const dropdownContentStyles = [styles.dropdownContent]

	if (!sectorsCards || sectorsCards.length == 0) {
		dropdownContentStyles.push(styles.noCards)
	}

	return (
		<ul className={styles.sectorsDropdown}>
			<li className={itemStyles.join(' ')}>
				<MegaMenuItem
					data={{ link: { title: 'Sectors', uri: sectorArchive.link } }}
					className={styles.triggerLink}
				/>

				{submenuData.length ? (
					<div className={styles.submenuWrapper}>
						<div className={styles.iconWrapper} onClick={() => setIsSubmenuOpen(!isSubmenuOpen)}>
							<ArrowIcon className={iconStyles.join(' ')} />
						</div>

						<div className={styles.dropdown}>
							<div className={dropdownContentStyles.join(' ')}>
								<Submenu data={submenuData} isOpen={isSubmenuOpen} className={styles.submenu} />

								{sectorsCards && sectorsCards.length > 0 ? (
									<MegaMenuCards data={sectorsCards} className={styles.cards} />
								) : null}
							</div>
						</div>
					</div>
				) : null}
			</li>
		</ul>
	)
}

export default SectorsDropdown
